import {ActionBuilder} from "@cuatroochenta/co-redux-builders";

export default ActionBuilder.build({
	dispatchClearReducer: () => ({})
})
